import styled from 'styled-components'

import { theme } from '@/styles/theme'
import { formatDate } from '@/utils/date'

import { PDFIcon } from '@/components/elements/Icon/PDF'

export type PDFItemType = {
  id: string
  date?: string
  fileName: string
  filePath: string
}

type Props = Omit<PDFItemType, 'id'>

export const PDFItem = ({ date, fileName, filePath }: Props) => {
  return (
    <StyledLink href={filePath} target="_blank" rel="noreferrer noopener">
      {date && <Time dateTime={date}>{formatDate(date, 'yyyy/MM/dd')}</Time>}
      <Icon />
      <Name>{fileName}</Name>
    </StyledLink>
  )
}

const Time = styled.time`
  font-weight: 700;
  line-height: 1.6;
`

const StyledLink = styled.a`
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 18px;
  padding-bottom: 20px;
  width: 100%;

  &:hover {
    > span {
      color: ${theme.colors.lightBlue};
      text-decoration: underline;
    }

    > svg {
      fill: ${theme.colors.lightBlue};
    }
  }
`

const Name = styled.span`
  line-height: 1.6;
`

const Icon = styled(PDFIcon)`
  flex-shrink: 0;
`
